import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
const SUBJECT_DETAILS_QUERY = gql `
  query EP_SubjectDetails($subjectID: ID!) {
    ep_subjectDetails(subjectID: $subjectID) {
      id
      data {
        title
      }
      attributes {
        totalQuestionCount
        answeredQuestionCount
      }
      type
      ancestorsDetails {
        community {
          id
          data {
            title
          }
        }
        examLevel {
          id
          data {
            title
          }
        }
      }
    }
  }
`;
export function useSubjectDetailsQuery(subjectID, options) {
    return useGQLQuery(SUBJECT_DETAILS_QUERY, {
        variables: {
            subjectID,
        },
        ...options,
    });
}
